module.exports = __webpack_public_path__ + "static/img/yytx02.b813f6c.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/details/yytx02.png
// module id = 874
// module chunks = 0